/**
 * Partner call-analysis tag icon picker: Lucide export `name` + UI label.
 * Tenant Voice UI resolves icons using the same `name` strings from the API.
 */
export const CALL_ANALYSIS_TAG_ICON_PICKER_OPTIONS = [
    { name: 'UserPlus', label: 'New lead / first-time caller' },
    { name: 'UserCheck', label: 'Existing customer' },
    { name: 'UserX', label: 'Unrecognized / wrong contact' },
    { name: 'Briefcase', label: 'Vendor / salesperson' },
    { name: 'Megaphone', label: 'Spam / unsolicited pitch' },
    { name: 'Ban', label: 'Blocked / unwanted caller' },
    { name: 'PhoneOff', label: 'Wrong number / misdial' },
    { name: 'Building2', label: 'Internal / staff / testing' },
    { name: 'Settings', label: 'Configuration / setup call' },
    { name: 'Sparkles', label: 'New service / sales inquiry' },
    { name: 'Wrench', label: 'Issue / problem report' },
    { name: 'Calendar', label: 'Scheduling / appointments' },
    { name: 'CalendarClock', label: 'Time-specific booking' },
    { name: 'CreditCard', label: 'Billing / payment' },
    { name: 'Receipt', label: 'Invoice / charges' },
    { name: 'Info', label: 'General information' },
    { name: 'HelpCircle', label: 'Questions / how-it-works' },
    { name: 'MessageSquare', label: 'Message for someone' },
    { name: 'Forward', label: 'Relay / transfer / pass along' },
    { name: 'User', label: 'Reach a specific person' },
    { name: 'XCircle', label: 'Cancellation / opt-out' },
    { name: 'Flame', label: 'Critical / emergency' },
    { name: 'Zap', label: 'Urgent / needs fast response' },
    { name: 'AlertTriangle', label: 'High priority' },
    { name: 'ArrowUp', label: 'Elevated / above normal' },
    { name: 'Minus', label: 'Normal / routine' },
    { name: 'ArrowDown', label: 'Low priority' },
    { name: 'Phone', label: 'Missed / no live conversation' },
    { name: 'ListTodo', label: 'Follow-up task / callback list' },
    { name: 'PhoneForwarded', label: 'Callback promised' },
    { name: 'Bell', label: 'Needs team attention' },
    { name: 'CheckCircle', label: 'Handled / resolved on call' },
    { name: 'Check', label: 'No further action' },
    { name: 'Tag', label: 'Generic tag' },
    { name: 'Hash', label: 'Category / code' },
    { name: 'Bookmark', label: 'Saved / notable' },
    { name: 'Flag', label: 'Flagged item' },
    { name: 'MapPin', label: 'Location / territory' },
    { name: 'Star', label: 'VIP / highlight' },
    { name: 'Package', label: 'Order / delivery / job' },
    { name: 'Home', label: 'Residential / property' },
    { name: 'Users', label: 'Group / household / team' },
    { name: 'Mail', label: 'Email channel' },
    { name: 'Clock', label: 'Time / SLA' },
    { name: 'ClipboardList', label: 'Checklist / details' },
];
/**
 * Icons that appeared in earlier picker sets and may still be referenced by existing
 * tag definitions. Not shown in the picker UI, but both partner and tenant resolvers
 * still map them so saved icons keep rendering.
 */
export const CALL_ANALYSIS_TAG_ICON_LEGACY_NAMES = [
    'AlertCircle',
    'Shield',
    'ThumbsUp',
    'ThumbsDown',
    'Leaf',
    'Droplets',
    'Eye',
];
const allIconNames = [
    ...CALL_ANALYSIS_TAG_ICON_PICKER_OPTIONS.map(o => o.name),
    ...CALL_ANALYSIS_TAG_ICON_LEGACY_NAMES,
];
/**
 * Maps a stored icon string to a picker or legacy `name` (exact Lucide export casing),
 * or null if it does not match any known option. Exact match wins over case-insensitive
 * (e.g. legacy "phone" → "Phone").
 */
export function resolveCallAnalysisTagIconName(storedName) {
    const trimmed = storedName.trim();
    if (!trimmed)
        return null;
    const lower = trimmed.toLowerCase();
    let caseInsensitiveMatch = null;
    for (const name of allIconNames) {
        if (name === trimmed)
            return name;
        if (caseInsensitiveMatch === null && name.toLowerCase() === lower) {
            caseInsensitiveMatch = name;
        }
    }
    return caseInsensitiveMatch;
}
//# sourceMappingURL=call-analysis-tag-icon-picker.js.map